var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "vs-row",
    { staticClass: "p-3 mt-2 shadow-sm bg-white" },
    [
      _c(
        "vs-col",
        { attrs: { "vs-lg": "7" } },
        [
          _c(
            "vs-row",
            [
              _c(
                "vs-col",
                { attrs: { "vs-lg": "3" } },
                [
                  _c(
                    "vs-chip",
                    {
                      nativeOn: {
                        click: function($event) {
                          return _vm.copyEmailToClipboard(_vm.item.id)
                        }
                      }
                    },
                    [
                      _c("vs-avatar", {
                        attrs: {
                          icon:
                            _vm.item.estado === "sended"
                              ? "check"
                              : _vm.item.estado === "error"
                              ? "error"
                              : _vm.item.estado === "empty"
                              ? "error"
                              : "timer",
                          color:
                            _vm.item.estado === "sended"
                              ? "green"
                              : _vm.item.estado === "error"
                              ? "red"
                              : _vm.item.estado === "empty"
                              ? "orange"
                              : "gray"
                        }
                      }),
                      _vm._v(" " + _vm._s(_vm.item.application) + " ")
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "vs-col",
                { attrs: { "vs-lg": "4" } },
                [
                  _c(
                    "vs-chip",
                    {
                      nativeOn: {
                        click: function($event) {
                          return _vm.copyEmailToClipboard(_vm.item.empresa)
                        }
                      }
                    },
                    [
                      _c("vs-avatar", {
                        attrs: { icon: "fingerprint", color: "gray" }
                      }),
                      _vm._v(" " + _vm._s(_vm.item.empresa) + " ")
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "vs-col",
                { staticClass: "text-truncate", attrs: { "vs-lg": "4" } },
                [
                  _c(
                    "vs-chip",
                    {
                      nativeOn: {
                        click: function($event) {
                          return _vm.copyEmailToClipboard(_vm.sender)
                        }
                      }
                    },
                    [
                      _c("vs-avatar", {
                        attrs: { icon: "send", color: "gray" }
                      }),
                      _vm._v(" " + _vm._s(_vm.sender) + " ")
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "vs-row",
            [
              _c(
                "vs-col",
                { attrs: { "vs-lg": "3" } },
                [
                  _c(
                    "vs-chip",
                    {
                      nativeOn: {
                        click: function($event) {
                          return _vm.copyEmailToClipboard(_vm.item.servicio)
                        }
                      }
                    },
                    [
                      _c("vs-avatar", {
                        attrs: { icon: "extension", color: "gray" }
                      }),
                      _vm._v(" " + _vm._s(_vm.item.servicio) + " ")
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "vs-col",
                { attrs: { "vs-lg": "4" } },
                [
                  _c(
                    "vs-chip",
                    {
                      nativeOn: {
                        click: function($event) {
                          return _vm.copyEmailToClipboard(_vm.localTimestamp)
                        }
                      }
                    },
                    [
                      _c("vs-avatar", {
                        attrs: { icon: "event", color: "gray" }
                      }),
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm._f("dateFormatDateTime")(_vm.localTimestamp)
                          ) +
                          " "
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "vs-col",
                { staticClass: "text-truncate", attrs: { "vs-lg": "4" } },
                _vm._l(_vm.item.destinatarios, function(destinatario) {
                  return _c(
                    "vs-chip",
                    {
                      key: destinatario,
                      nativeOn: {
                        click: function($event) {
                          return _vm.copyEmailToClipboard(destinatario)
                        }
                      }
                    },
                    [
                      _c("vs-avatar", { attrs: { icon: "email" } }),
                      _vm._v(" " + _vm._s(destinatario) + " ")
                    ],
                    1
                  )
                }),
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("vs-col", { attrs: { "vs-lg": "4" } }, [
        _vm._v(" " + _vm._s(_vm.item.subject) + " ")
      ]),
      _c(
        "vs-col",
        {
          attrs: {
            "vs-lg": "1",
            "vs-type": "flex",
            "vs-justify": "center",
            "vs-align": "center"
          }
        },
        [_c("Options", { attrs: { item: _vm.item } })],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }